import { RSAA } from 'redux-api-middleware';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import type { FetchFuelEconomyPayload } from '../types';
import { FETCH_FUEL_ECONOMY_REQUEST, FETCH_FUEL_ECONOMY_SUCCESS, FETCH_FUEL_ECONOMY_FAILURE } from '../store/actions';

export const fetchFuelEconomy = (payload: FetchFuelEconomyPayload): RSAACallAction => {
    const locHref = locHrefUtil.getLocHref();
    const endpoint = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '/vehicle/fuelEconomy').url;
    const request: RSAACallRequest = {
        endpoint,
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        types: [FETCH_FUEL_ECONOMY_REQUEST, FETCH_FUEL_ECONOMY_SUCCESS, FETCH_FUEL_ECONOMY_FAILURE],
        fetch: async (...args: Parameters<typeof fetch>) => await fetch(...args)
    };
    return { [RSAA]: request } as RSAACallAction;
};
